import { Controller } from "@hotwired/stimulus";

// A filter form that applies itself when a field is changed with the mouse
// or by touch. Keyboard changes wait for the Apply button: arrowing through a
// closed select changes its value on every key press (Windows, Linux), and
// reloading each time would throw the user back to the top of the page.
//
// A field with data-auto-submit-clears="other" empties that other field when
// it changes (e.g. a new year clears the month, which may not exist then).
// Empty fields are left out when submitting, so the address only shows the
// filters in use.
export default class extends Controller {
  connect() {
    this.byKeyboard = false;
  }

  keyboard() { this.byKeyboard = true; }

  pointer() { this.byKeyboard = false; }

  change(event) {
    const clears = event.target.dataset.autoSubmitClears;
    if (clears && this.element.elements[clears]) this.element.elements[clears].value = "";
    if (!this.byKeyboard) this.element.requestSubmit();
  }

  // On submit (automatic or Apply): leave out empty fields.
  omitEmpty() {
    const empty = [...this.element.elements].filter((field) => field.name && field.value === "" && !field.disabled);
    empty.forEach((field) => { field.disabled = true; });
    // Re-enable once the request has been built, in case this page is shown again (back button).
    setTimeout(() => empty.forEach((field) => { field.disabled = false; }));
  }
}
